<template>
    <section class="information-header" :class="{ 'has-download-header': hasDownloadHeader }">
        <section class="special-list" v-if="specialList.length > 0">
            <div class="special-list-item" v-for="(item, index) in specialList" :key="index" @click="$emit('go-special', item.id)">
                <i class="icon-special"></i>
                <p>{{ item.title }}</p>
            </div>
        </section>
        <h3 class="information-title" v-if="title" v-html="title"></h3>
        <p class="information-desc">{{ source }} {{ publishText }}</p>
    </section>
</template>

<script>
export default {
    name: 'ArticleHeader',
    props: {
        specialList: {
            type: Array,
            default: () => []
        },
        title: {
            type: String,
            default: ''
        },
        source: {
            type: String,
            default: ''
        },
        publishText: {
            type: String,
            default: ''
        },
        hasDownloadHeader: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="less" scoped>
@import url('../css/mixins.less');

.information-header {
    &.has-download-header {
        padding-top: 80px;
    }
}

.special-list {
    margin-bottom: 16px;
}

.special-list-item {
    position: relative;
    #font_h1();
    #box_shadow();

    .icon-special {
        position: absolute;
        top: 50%;
        left: 0;
        width: 14px;
        height: 14px;
        margin-top: -8px;
        background: url('~@/assets/images/information/special.jpg') no-repeat center;
        background-size: 100%;
    }

    p {
        padding: 8px 0 8px 20px;
        font-size: 14px;
    }
}

.information-title {
    margin-bottom: 16px;
    font-weight: 600;
    font-size: 21px;
    line-height: 1.5;
    text-align: left;
    word-wrap: break-word;
    text-align: justify;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    color: #181818;

    #news_title();
}

.information-desc {
    padding: 0 0 12px;
    color: #9c9c9c;
    text-align: justify;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    font-style: normal;
    #news_desc();

    span {
        margin-left: 8px;
    }
}
</style>
